import { PhoneNumberUtil } from 'google-libphonenumber'

export const phoneUtil = PhoneNumberUtil.getInstance()

export const isValidPhoneNumber = (value) => {
    if (!value) return false
    let parsed = tryParse(value)
    if (parsed === null) return false
    return phoneUtil.isValidNumber(parsed)
}

export const tryParse = (value) => {
    try {
        return phoneUtil.parse(value)
    } catch (e) {
        return null
    }
}

export const formatPhone = (value, format) => {
    return isValidPhoneNumber(value)
        ? phoneUtil.format(tryParse(value), format)
        : value
}
